import React, { useState } from "react";
import Api from "../../../../../core/data/redux/utils/apiCall";
import { API_URLS } from "../../../../../core/data/redux/apis/urls";

interface NocHeaderProps {
  title: string;
  breadcrumbTitle: string;
  nocType: string;
  nocData: any;
  onBack: () => void;
  onRefresh: () => void;
  onShowToast: (title: string, message: string, type: "success" | "danger" | "warning" | "primary") => void;
}

export const NocHeader: React.FC<NocHeaderProps> = ({
  title,
  breadcrumbTitle,
  nocType,
  nocData,
  onBack,
  onRefresh,
  onShowToast,
}) => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadNocPDF = async () => {
    if (!nocData || isDownloading) return;
    try {
      setIsDownloading(true);
      const sapTypeMap: Record<string, string> = {
        NOC_OUTJOB: "ZNOJ",
        NOC_EXINDIA: "ZNEX",
        NOC_HIGHERSTUDY: "ZHIS",
        NOC_PASSPORT: "ZNVP",
        NOC_ONLINECOURSE: "ZNOC",
      };
      const sapType = sapTypeMap[nocType] || "ZNOJ";
      const payload = {
        empId: nocData.empID || nocData.empId,
        type: sapType,
        referenceNumber: nocData.referenceNumber,
      };

      const res: any = await Api.post(API_URLS.NOC.DOWNLOAD_DOC, payload);
      const docItem = res?.data?.data?.[0] || res?.data;
      if (res?.data?.success && docItem?.url) {
        window.open(docItem.url, "_blank");
      } else {
        onShowToast("Error", res?.data?.message || "Failed to download NOC document.", "danger");
      }
    } catch (err: any) {
      console.error("NOC Download Error:", err);
      onShowToast("Error", err?.message || "Failed to download NOC document.", "danger");
    } finally {
      setIsDownloading(false);
    }
  };

  const showDigitalNocDownload =
    Boolean(nocType && ["NOC_HIGHERSTUDY", "NOC_OUTJOB", "NOC_EXINDIA"].includes(nocType)) &&
    nocData?.requestStatus?.toUpperCase() === "D";

  return (
    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <div className="my-auto mb-2">
        <h2 className="mb-1">{title}</h2>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="#" onClick={(e) => { e.preventDefault(); onBack(); }}>
                Tasks
              </a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {breadcrumbTitle}
            </li>
          </ol>
        </nav>
      </div>
      <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
        {showDigitalNocDownload && (
          <button
            onClick={handleDownloadNocPDF}
            className="btn btn-success d-flex align-items-center"
            disabled={isDownloading}
          >
            <i className="ti ti-download me-2"></i>
            {isDownloading ? "Downloading..." : "Download Digital NOC"}
          </button>
        )}
        <button
          onClick={onRefresh}
          className="btn btn-outline-primary d-flex align-items-center"
        >
          <i className="ti ti-refresh me-2"></i>
          Refresh
        </button>
        <button
          onClick={onBack}
          className="btn btn-secondary d-flex align-items-center"
        >
          <i className="ti ti-arrow-left me-2"></i>
          Back
        </button>
      </div>
    </div>
  );
};
